import type { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  label: string;
  title: string;
  action?: { icon: string; onClick?: () => void; primary?: boolean };
  /** Default: navigate("/profil"). Wenn deine App keinen /profil-Pfad hat: override. */
  onMenu?: () => void;
  children?: ReactNode;
};

export function MTopBar({ label, title, action, onMenu, children }: Props) {
  const navigate = useNavigate();
  return (
    <div className="m-topbar">
      <div className="m-topbar-row">
        <button className="m-topbar-back" onClick={onMenu ?? (() => navigate("/profil"))}>☰</button>
        <div className="m-topbar-title">
          <div className="m-topbar-pretitle">{label}</div>
          <div className="m-topbar-mainttl">{title}</div>
        </div>
        {action ? (
          <button
            className={`m-topbar-action ${action.primary ? "is-primary" : ""}`}
            onClick={action.onClick}
          >
            {action.icon}
          </button>
        ) : null}
      </div>
      {children}
    </div>
  );
}
